module.exports = __webpack_public_path__ + "static/taylor-f9446348c7e38b23a2f87f57f18c6bf1.png";